import { formmatNumFixN } from "./format";

export const selfInvoicingYear = (val) => {
    if (!val) return "*";
    const year = formmatNumFixN(val / 365, 0, false);
    const day = val % 365;
    if (year == 0 && day == 0) return "*";
    if (year == 0) return `${day}天`;
    if (day == 0) return `${year}年`;
    return `${year}年${day}天`;
};

// PCS、PV、ESS 的错误信息对应的颜色：按照E1显示红色、E2/E3显示黄色；F1显示红色，F2/F3显示黄色；
export const formmatErrorLevel = it => {
    if (it.level === 1 || it.subLevel === 1) return "error_level_1";
    if (it.level === 2 || [2, 3].includes(it.subLevel)) return "error_level_2";
};
